import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdateTtbPaymentModuleForm, { type FormValues } from './UpdateTtbPaymentModuleForm';

type UpdateTtbPaymentModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdateTtbPaymentModuleDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: UpdateTtbPaymentModuleDrawerProps) => {
    const { t } = useTranslation(['ttbPaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('ttbPaymentModuleDetails:paymentModuleDrawer.cancelButton')}</Button>
                    <Button form="updateTtbPaymentModule" htmlType="submit" type="primary">
                        {t('ttbPaymentModuleDetails:paymentModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('ttbPaymentModuleDetails:paymentModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdateTtbPaymentModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdateTtbPaymentModuleDrawer;

export const useUpdateTtbPaymentModuleDrawer = (
    moduleId: string,
    initialValues: UpdateTtbPaymentModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdateTtbPaymentModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
